import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

import { TopBar } from "../components/TopBar";

export const Route = createFileRoute("/_app")({
  // Auth gate for every page nested under `_app`.
  // Runs before any child loader, so we can redirect synchronously.
  beforeLoad: ({ context, location }) => {
    if (context.auth.status !== "authenticated") {
      throw redirect({
        to: "/login",
        search: { redirect: location.href },
      });
    }
    const user = context.auth.user;
    if (
      user?.role === "production" &&
      !["/erp/orders", "/erp/products", "/erp/raw-materials", "/erp/inventory"].some(
        (prefix) => location.pathname === prefix || location.pathname.startsWith(prefix + "/"),
      )
    ) {
      throw redirect({ to: "/erp/orders" });
    }
  },
  component: AppLayout,
});

function AppLayout() {
  return (
    <div className="flex min-h-[100dvh] flex-col">
      <TopBar />
      <main className="safe-bottom flex-1">
        <Outlet />
      </main>
    </div>
  );
}
